import app from '../main'

const helper = {
    setStorage(name,value){
        if(!name){
            return false;
        }
        let data={};
        if(typeof value === 'object'){
            data.type='object'
        }else{
            data.type='string';
        }
        data.value=value;
        window.localStorage.setItem(name,JSON.stringify(data));
    },
    getStorage(name){
        let data=window.localStorage.getItem(name);
        if(!data){
            return null;
        }
        data=JSON.parse(data);
        return data.value;
    },
    checkEditor(key){
        
        const allowEditors = app.$store.state.authInfo.allow_editors;
        if(allowEditors[key]){
            return true;
        }else{
            app.$notification.error({ type: 'danger', message: '权限不足',description:'抱歉，您没有权限执行此操作' });
            return false;
        } 
    },
    copyText(text){
        var input = document.createElement("input");
        input.value = text; // 修改文本框的内容
        input.id = 'copy-input';
        document.body.append(input);
        input.select(); // 选中文本
        document.execCommand("copy"); // 执行浏览器复制命令
        document.getElementById('copy-input').remove();
        app.$message.success('复制成功');
    }
}
export default helper;